import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { AgitateSection } from './components/AgitateSection';
import { QuestionsSection } from './components/QuestionsSection';
import { MistakesSection } from './components/MistakesSection';
import { SystemRevealSection } from './components/SystemRevealSection';
import { ProblemFinderSection } from './components/ProblemFinderSection';
import { IncludesSection } from './components/IncludesSection';
import { EbookCarouselSection } from './components/EbookCarouselSection';
import { MidPageCta } from './components/MidPageCta';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { ComparisonSection } from './components/ComparisonSection';
import { IndependenceSection } from './components/IndependenceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-abyss-950 pb-20 font-sans text-body lg:pb-0" data-id="element-0" data-mp="6801qozk67w">
      <Hero data-id="element-1" data-mp="2zld2xbxu5jcl" />

      <main data-id="element-2" data-mp="2zlv6ktmtuzuj">
        <PainSection data-id="element-3" data-mp="2zm4wyibsb90r" />
        <AgitateSection data-id="element-4" data-mp="2zmo89g6xiz5t" />
        <QuestionsSection data-id="element-5" data-mp="2zng2amkvootz" />
        <MistakesSection data-id="element-6" data-mp="33m5ck6amdq9e" />
        <SystemRevealSection data-id="element-7" data-mp="33ngee0ki8nxv" />
        <ProblemFinderSection data-id="element-8" data-mp="33orjc3pos1qk" />
        <IncludesSection data-id="element-9" data-mp="38m1jadapbvsn" />
        <EbookCarouselSection data-id="element-10" data-mp="38kqafz2efxuo" />
        <MidPageCta data-id="element-11" data-mp="38kgnylgkc8tq" />
        <BonusesSection data-id="element-12" data-mp="3dkuufz2inapn" />
        <OfferSection data-id="element-13" data-mp="3dle4ktlxcut4" />
        <ComparisonSection data-id="element-14" data-mp="3dlnru9fl4nv4" />
        <IndependenceSection data-id="element-15" data-mp="3dirwmsv4gdad" />
        <GuaranteeSection data-id="element-16" data-mp="nvstj3irmlvf" />
        <FaqSection data-id="element-17" data-mp="nuhhyhj2w9tr" />
        <FinalOfferSection data-id="element-18" data-mp="nv1284w7baay" />
      </main>

      <Footer data-id="element-19" data-mp="sudl6ejybx89" />
      <StickyCta data-id="element-20" data-mp="su42lc18kscl" />
    </div>;
}